export default function deleteSiteReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_SITE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_SITE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_SITE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}